/**
 * <mobile-nav> — open/close + focus trap + body scroll lock.
 * Looks for [data-mobile-nav-open], [data-mobile-nav-close], and a [data-mobile-nav-panel] inside.
 */

class MobileNav extends globalThis.ThemeElement {
  connectedCallback() {
    this.panel = this.$('[data-mobile-nav-panel]');
    /* Triggers live OUTSIDE this element (header burger, etc.), so query document scope. */
    this.openers = Array.from(document.querySelectorAll('[data-mobile-nav-open]'));
    this.closers = Array.from(document.querySelectorAll('[data-mobile-nav-close]'));
    this._releaseFocus = null;

    for (const btn of this.openers) this.on(btn, 'click', this.open.bind(this));
    for (const btn of this.closers) this.on(btn, 'click', this.close.bind(this));
    this.on(window, 'keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    /* Allow other elements (cart drawer trigger, predictive search) to dispatch open events. */
    this.on(globalThis.ThemeBus, 'mobile-nav:open', this.open.bind(this));
    this.on(globalThis.ThemeBus, 'mobile-nav:close', this.close.bind(this));
  }

  get isOpen() { return this.hasAttribute('open'); }

  open() {
    if (this.isOpen) return;
    this.setAttribute('open', '');
    this.panel?.removeAttribute('hidden');
    globalThis.JunneTheme.lockBodyScroll();
    this._releaseFocus = globalThis.JunneTheme.trapFocus(this.panel || this);
    this.emit('drawer:open', { name: 'mobile-nav' });
  }

  close() {
    if (!this.isOpen) return;
    this.removeAttribute('open');
    this.panel?.setAttribute('hidden', '');
    globalThis.JunneTheme.unlockBodyScroll();
    this._releaseFocus?.();
    this._releaseFocus = null;
    this.emit('drawer:close', { name: 'mobile-nav' });
  }
}

if (!customElements.get('mobile-nav')) customElements.define('mobile-nav', MobileNav);
